import React, { useEffect, useMemo, useState } from "react";
import Table from "../../../components/Table";
import { connect } from "react-redux";

import { setAuthorize } from "../../../actions/app-action-types";
import Icon from "../../../components/Icon";
import { Circle } from "../../../components/Overlay";
import styled from "styled-components";
import Button from "../../../components/Button";
import AddEditorModal from "./components/AddEditorModal";
import {
  addEditor,
  getAllEditors,
  updateEditor,
} from "../../../actions/user-action-types";
import { get, isEmpty } from "lodash";
import { toast } from "react-toastify";
import { Typography } from "@mui/material";

////********Styled Components ********************/
const MainContainer = styled.div`
  padding: 20px 40px;
  overflow: hidden;
`;

const TopContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const LoaderContainer = styled.div`
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  justify-content: center;
  background-color: rgb(0, 0, 0, 0.3);
  align-items: center;
`;

const EditorsManagement = ({
  userData,
  allEditors,
  getAllEditors,
  visible,
  addEditor,
  updateEditor,
}) => {
  const [showAddEditorModal, setShowAddEditorModal] = useState(false);
  const [editorData, setEditorData] = useState({});

  const loadData = () => {
    getAllEditors({ role: 17, page: 0, tenant: "AG", size: 1000 });
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddEditorSubmit = (values) => {
    const reqPayload = {
      created_by: userData?.user_id ?? "ADMIN",
      name: values.name?.trim(),
      email_id: values.email,
      mobile_no: values.mobileNumber,
      runId: values.mobileNumber,
      status: 1,
      user_role: 17,
    };
    addEditor({
      params: reqPayload,
      onSuccess: (response) => {
        console.log("response", response);
        setShowAddEditorModal(false);
        setEditorData({});
        loadData();
        toast.success(response?.message ?? "Added Successfully", {
          position: toast.POSITION.TOP_RIGHT,
        });
      },
      onError: (error) => {
        console.log("errror ", error);
        const errorMsg =
          get(error, "error.response.data.message") ??
          "Something went wrong, Please try again later.";
        toast.error(errorMsg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      },
    });
  };

  const handleUpdateEditorSubmit = (values) => {
    const reqPayload = {
      modified_by: userData?.user_id ?? "ADMIN",
      name: values.name,
      email_id: values.email,
      mobile_no: values.mobileNumber,
      runId: values.mobileNumber,
      oldRunId:
        values.mobileNumber !== editorData?.user_id
          ? editorData?.user_id
          : undefined,
      status: 1,
      requestId: editorData?.request_id,
    };
    updateEditor({
      params: reqPayload,
      onSuccess: (response) => {
        console.log("response", response);
        setShowAddEditorModal(false);
        setEditorData({});
        loadData();

        toast.success(response?.message ?? "Updated Successfully", {
          position: toast.POSITION.TOP_RIGHT,
        });
      },
      onError: (error) => {
        console.log("errror ", error);
        const errorMsg =
          get(error, "error.response.data.message") ??
          "Something went wrong, Please try again later.";
        toast.error(errorMsg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      },
    });
  };

  const columns = [
    {
      Header: "Sl No.",
      accessor: "srNo",
      maxWidth: 50,
      style: { textAlign: "center" },
    },
    {
      Header: "Actions",
      accessor: "user_id",
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
      Cell: (item) => {
        return (
          <div
            style={{
              marginRight: "8px",
              marginLeft: "8px",
              cursor: "pointer",
            }}
            onClick={() => {
              setEditorData(item.row.original);
              setShowAddEditorModal(true);
            }}
          >
            <Icon icon="edit" />
          </div>
        );
      },
      maxWidth: 80,
    },
    {
      Header: "Status",
      accessor: "status",
      maxWidth: 80,
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
      Cell: (row) => {
        return (
          <text
            style={{
              fontFamily: "Roboto-Regular",
              fontSize: "12px",
              color: row.value === 1 ? "#227700" : "#CC0000",
            }}
          >
            {row.value === 1 ? "Active" : "Inactive"}
          </text>
        );
      },
    },
    {
      Header: "Name",
      accessor: "name",
      maxWidth: 120,
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
    },
    {
      Header: "Mobile Number",
      accessor: "mobile_no",
      maxWidth: 200,
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
    },
    {
      Header: "Email",
      accessor: "email_id",
      maxWidth: 200,
      headerStyle: { textAlign: "center" },
      style: { textAlign: "center" },
    },
  ];

  const tableData = useMemo(() => {
    return (
      allEditors?.map((item, index) => ({
        ...item,
        srNo: index + 1,
      })) || []
    );
  }, [allEditors]);

  return (
    <>
      <MainContainer>
        <TopContainer>
          <Typography
            variant="h5"
            fontWeight={700}
            color={"#003E85"}
            marginBottom={2}
          >
            {"Editors"}
          </Typography>
          <Button
            label="Add New Editor"
            labelColor={"white"}
            onClick={() => setShowAddEditorModal(true)}
          />
        </TopContainer>
        <Table
          stickyHeader={true}
          columns={columns}
          data={tableData}
          defaultPageSize={10}
          filterSearchTop={"34px"}
          headerZIndex={1}
        />
        {showAddEditorModal && (
          <AddEditorModal
            isEditMode={!isEmpty(editorData)}
            editorData={editorData}
            isLoading={visible}
            onCancel={() => {
              setShowAddEditorModal(false);
              setEditorData({});
            }}
            onSubmit={(values) => {
              if (!isEmpty(editorData)) {
                handleUpdateEditorSubmit(values);
              } else {
                handleAddEditorSubmit(values);
              }
            }}
          />
        )}
      </MainContainer>
      {visible && (
        <LoaderContainer>
          <Circle size="Large" />
        </LoaderContainer>
      )}
    </>
  );
};

const mapStateToProps = ({
  app: { visible, isUnauthorize },
  user: { userData, allEditors },
}) => ({
  userData,
  allEditors,
  visible,
  isUnauthorize,
});

export default connect(mapStateToProps, {
  getAllEditors: getAllEditors,
  addEditor: addEditor,
  updateEditor: updateEditor,
  setAuthorize,
})(EditorsManagement);
